import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'register-guide-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=register-guide-01&orientation=landscape',
  'features-intro-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=features-intro-01&orientation=landscape',
  'update-news-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=update-news-01&orientation=landscape',
  'faq-common-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=faq-common-01&orientation=landscape',
  'security-guide-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=security-guide-01&orientation=landscape',
  'pro-tips-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=pro-tips-01&orientation=landscape',
  'mobile-guide-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=mobile-guide-01&orientation=landscape',
  'data-analysis-01': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20article%20illustration%20with%20soft%20gradient%20background%2C%20warm%20coral%20and%20cream%20tones%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20subtle%20texture%2C%20professional%20blog%20featured%20image&width=800&height=400&seq=data-analysis-01&orientation=landscape',
};

export default function LatestArticlesSection() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-16 gap-4">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              最新文章
            </h2>
            <p className="text-foreground-500 text-base">
              探索 17c.cc 最新发布的内容与教程
            </p>
          </div>
          <Link
            to="/category/guide"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-primary-200 text-primary-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span className="text-sm font-medium">查看全部</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq] || articleImages['register-guide-01']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 text-xs rounded-full bg-secondary-100 text-secondary-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}